import React from 'react'

import close from './../../UI/loading/cerrar.svg'

interface Props{
    isTuto: boolean
    handleOpenTutorialVideo: any
}

interface State{}

class Tutorial extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isTuto ? 'main-tuto-container fade-in':'main-tuto-container fade-out'}>
                <div className='tuto-close-btn' onClick={() => {this.props.handleOpenTutorialVideo(false)}}>
                    <img src={close}/>
                </div>
                <div className={ this.props.isTuto ? 'video-tuto-container fade-in':'video-tuto-container fade-out'}>
                    <iframe 
                        src={this.props.isTuto ? "https://www.youtube.com/embed/nLY8rUQxeX8?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0":""} 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"    
                        className={this.props.isTuto ? "recor-360-frame fade-in":"recor-360-frame fade-out"}
                    />
                </div>
            </div>
        )
    }
}

export default Tutorial